import { render, staticRenderFns } from "./CenterLeftMenu.vue?vue&type=template&id=47c9b856&scoped=true&"
import script from "./CenterLeftMenu.vue?vue&type=script&lang=js&"
export * from "./CenterLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./CenterLeftMenu.vue?vue&type=style&index=0&id=47c9b856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c9b856",
  null
  
)

export default component.exports